import { render, staticRenderFns } from "./uploadAudio.vue?vue&type=template&id=5e0b3456&scoped=true"
import script from "./uploadAudio.vue?vue&type=script&lang=js"
export * from "./uploadAudio.vue?vue&type=script&lang=js"
import style0 from "./uploadAudio.vue?vue&type=style&index=0&id=5e0b3456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b3456",
  null
  
)

export default component.exports